import { createAction } from '@reduxjs/toolkit';

import { GeneralAdvancementDetails } from '@appTypes/esb';

import { advRequirementOperations, moduleName } from '../constants';

export const editAdvRqmtsRequest = createAction<{
  requirements: {
    id: string;
    dateCompleted: string;
  }[];
  dateCompleted?: string;
  omitOrganizationGuid?: boolean;
  operation?: advRequirementOperations;
  onSuccess?: VoidFunction;
}>(`${moduleName}/EDIT_ADV_RQMTS_REQUEST`);

export const editAdvRqmtsResponse = createAction(
  `${moduleName}/EDIT_ADV_RQMTS_RESPONSE`,
);
export const editAdvRqmtsError = createAction<Error>(
  `${moduleName}/EDIT_ADV_RQMTS_ERROR`,
);
export const editPreferedName = createAction(
  `${moduleName}/EDIT_PREFERED_NAME`,
);

export const editAdvRqmtsStopLoadingRequest = createAction(
  `${moduleName}/EDIT_ADV_RQMTS_STOP_LOADING_REQUEST`,
);
export const editAdvRqmtsStopLoadingSuccess = createAction(
  `${moduleName}/EDIT_ADV_RQMTS_STOP_LOADING_SUCCESS`,
);

export const advancementVersionResponse = createAction<{
  advancementType: string;
  advancementId: string;
  details: GeneralAdvancementDetails;
}>(`${moduleName}/ADVANCEMENT_VERSION_RESPONSE`);

export const advancementVersionError = createAction<{
  advancementType: string;
  advancementId: string;
}>(`${moduleName}/ADVANCEMENT_VERSION_ERROR`);

export const changeMultipleBlueCardModal = createAction(
  `${moduleName}/CHANGE_MULTIPLE_BLUE_CARD_MODAL`,
);
